import React from 'react'
import Link from '../Link'

const Marks = {
  link: ({ children, value }) => {
    const { href } = value

    return (
      <Link to={href}>
        {children}
      </Link>
    )
  }
}

export default Marks;
